import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1599.04,1523.62667 L396.373333,320.96 C546.88,188.053333 743.786667,106.666667 960,106.666667 C1430.50667,106.666667 1813.33333,489.493333 1813.33333,960 C1813.33333,1176.10667 1731.94667,1373.12 1599.04,1523.62667 M106.666667,960 C106.666667,743.786667 187.946667,546.88 320.96,396.373333 L1523.62667,1599.04 C1373.12,1731.94667 1176.10667,1813.33333 960,1813.33333 C489.493333,1813.33333 106.666667,1430.50667 106.666667,960 M960,0 C429.76,0 0,429.76 0,960 C0,1490.24 429.76,1920 960,1920 C1490.13333,1920 1920,1490.24 1920,960 C1920,429.76 1490.13333,0 960,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoLine = /*#__PURE__*/function (_Component) {
  _inherits(IconNoLine, _Component);

  var _super = _createSuper(IconNoLine);

  function IconNoLine() {
    _classCallCheck(this, IconNoLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconNoLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNoLine.displayName = "IconNoLine";
  return IconNoLine;
}(Component);

IconNoLine.glyphName = 'no';
IconNoLine.variant = 'Line';
IconNoLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoLine;
export { IconNoLine };